/**
 * Staun Announcement Ticker
 * Smooth infinite horizontal scroll for the announcement bar.
 * No inline scripts — loaded via the section file with defer.
 */

'use strict';

(() => {
  const ticker = document.querySelector('[data-staun-ticker]');
  if (!ticker) return;

  const track = ticker.querySelector('[data-staun-ticker-track]');
  if (!track) return;

  /* Speed from section settings (data attribute fallback) */
  const section = ticker.closest('[class*="shopify-section"]');
  const speed = parseInt(ticker.dataset.speed, 10) || 50;

  let offset = 0;
  let rafId = null;
  let lastTimestamp = 0;
  let isPaused = false;

  /**
   * Calculate the width of half the track (original items only, not duplicates).
   * We duplicated the blocks in Liquid so the track is 2x the content width.
   */
  const getResetPoint = () => track.scrollWidth / 2;

  const animate = (timestamp) => {
    if (!lastTimestamp) lastTimestamp = timestamp;
    const delta = timestamp - lastTimestamp;
    lastTimestamp = timestamp;

    if (!isPaused) {
      offset -= (speed * delta) / 1000;

      const resetPoint = getResetPoint();
      if (Math.abs(offset) >= resetPoint) {
        offset += resetPoint;
      }

      track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }

    rafId = requestAnimationFrame(animate);
  };

  /* Pause on hover for accessibility */
  ticker.addEventListener('mouseenter', () => { isPaused = true; });
  ticker.addEventListener('mouseleave', () => { isPaused = false; });

  /* Pause when tab is not visible to save resources */
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      isPaused = true;
    } else {
      isPaused = false;
      lastTimestamp = 0;
    }
  });

  /* Respect reduced motion preference */
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motionQuery.matches) {
    track.style.transform = 'none';
    return;
  }

  motionQuery.addEventListener('change', (e) => {
    if (e.matches) {
      cancelAnimationFrame(rafId);
      track.style.transform = 'none';
    } else {
      rafId = requestAnimationFrame(animate);
    }
  });

  /* Start animation */
  rafId = requestAnimationFrame(animate);
})();
